import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { historyActions } from '../../../application/actions/history';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETBYID
export function* getByIdFetch(e) {
    yield put(historyActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `history/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(historyActions.getById({data}));
    } catch (err) {
        yield put(historyActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(historyActions.conexionGetById({connection:false}));
    }
}


export function* watchFetchHistory() {
    yield takeLatest(historyActionsSaga.getById.type,  getByIdFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchHistory);
}



const getById = createAction('historySaga/getById');

export const historyActionsSaga = {
    getById
};
